import { Box, Button, Paper, Stack, Typography } from "@mui/material";

export default function EmptyState({ title = "Kayıt bulunamadı", description, actionLabel, onAction }) {
  return (
    <Paper sx={{ p: 3 }}>
      <Stack spacing={1.25} alignItems="flex-start">
        <Typography variant="h6" sx={{ fontWeight: 800 }}>
          {title}
        </Typography>
        {description ? (
          <Typography variant="body2" color="text.secondary">
            {description}
          </Typography>
        ) : null}
        {actionLabel && onAction ? (
          <Box sx={{ pt: 1 }}>
            <Button variant="contained" onClick={onAction}>
              {actionLabel}
            </Button>
          </Box>
        ) : null}
      </Stack>
    </Paper>
  );
}
